import { useState, useEffect } from 'react';
import { Box } from '@mui/material';

import FormHeader from './components/FormHeader';
import TopFormSection from './components/TopFormSection';
import BottomFormSection from './components/BottomFormSection';
import ConfirmationDialog from './components/ConfirmationDialog';

import { useGenerateCoupons } from './hooks/useGenerateCoupons';
import { useUserLogged } from '../../hooks/useUserLogged';
import { useBranches } from '../../hooks/useBranches';
import { usePlans } from '../../hooks/usePlans';
import { useGroups } from '../../hooks/useGroups';
import { usePaymentMethods } from '../../hooks/usePaymentMethods';

const GenerateCouponsForm = () => {
  const [showAdecuacion, setShowAdecuacion] = useState('');

  const { branch } = useUserLogged();
  const { data: branches = [] } = useBranches();
  const { data: plans = [] } = usePlans();
  const { data: groups = [] } = useGroups();
  const { data: paymentMethods = [] } = usePaymentMethods();

  const {
    isLoading,
    showPopup,
    popupData,
    excludedContracts,
    noCalculateInterest,
    formData,
    dueDates,
    dueDatesCalendar,
    diffValues,
    handleFormChange,
    handleDueDateChange,
    handleDateCalendarChange,
    handleInterestCheckboxChange,
    handleExcludedContractsChange,
    handleGenerateClick,
    handleConfirmGeneration,
    handleClosePopup,
    handleNavigateToCoupons,
  } = useGenerateCoupons(paymentMethods);

  useEffect(() => {
    if (branch && branch[0] && branches && branches[0] && plans && plans[0]) {
      handleFormChange('branch', branch[0]?.uuid_branch || branches[0].uuid);
      handleFormChange('plan', plans[0].uuid);
      handleFormChange('group', 'all');
    }
  }, [branch, branches, plans, handleFormChange]);

  return (
    <>
      <Box>
        <FormHeader onButtonClick={handleGenerateClick} isLoading={isLoading} />

        <Box>
          <TopFormSection
            formData={formData}
            onFormChange={handleFormChange}
            branches={branches}
            plans={plans}
            groups={groups}
            paymentMethods={paymentMethods}
            onAdecuacionChange={setShowAdecuacion}
          />

          <BottomFormSection
            showAdecuacion={showAdecuacion}
            paymentMethods={paymentMethods}
            paymentMethodUuid={formData.paymentMethod}
            dueDates={dueDates}
            dueDatesCalendar={dueDatesCalendar}
            diffValues={diffValues}
            noCalculateInterest={noCalculateInterest}
            defermentPercentage={formData.defermentPercentage}
            onDueDateChange={handleDueDateChange}
            onDateCalendarChange={handleDateCalendarChange}
            onInterestCheckboxChange={handleInterestCheckboxChange}
          />
        </Box>
      </Box>

      <ConfirmationDialog
        open={showPopup}
        onClose={handleClosePopup}
        data={popupData}
        onConfirm={handleConfirmGeneration}
        onNavigate={handleNavigateToCoupons}
        excludedContracts={excludedContracts}
        onExcludedContractsChange={handleExcludedContractsChange}
      />
    </>
  );
};

export default GenerateCouponsForm;
